export enum EModesReglement {
	carte_bancaire = "Carte bancaire",
	cheque = "Chèque",
	virement = "Virement",
	espece = "Espèce",
}
